import { AuthContext } from '@e3dc-react/shell/Libs/authentication'
import { useContext, useEffect } from 'react'
import { useLocation, useNavigate } from 'react-router-dom'
import { REDIRECT_URL_KEY } from 'src/Libs/navigation/consts'

/*
 * Custom hook to require authentication before rendering a component
 * Saves the current URL and redirects there after successful login
 */
const useRequireAuth = (): void => {
  const valid = useContext(AuthContext).valid
  const location = useLocation()
  const navigate = useNavigate()

  useEffect(() => {
    if (!valid) {
      localStorage.setItem(REDIRECT_URL_KEY, `${location.pathname}${location.search}`)
      navigate('/login')
    }
  }, [valid, location.pathname, location.search, navigate])
}

export default useRequireAuth
